import { Types } from '@store/types';

export const setBuyerRequestFilterField = (prevData, payload) => async (dispatch) => {
	let data = prevData;
	if (payload.title === 'Request') {
		data = { ...data, requestedBy: { id: payload.id, value: payload.value } };
	} else {
		data = { ...data, date: { id: payload, value: payload } };
	}
	await dispatch({
		type: Types.SET_BUYER_REQUEST_FILTER_DATA,
		payload: data
	});
};

export const setBuyerRequestActiveTab = (payload) => async (dispatch) => {
	await dispatch({
		type: Types.SET_BUYER_REQUEST_ACTIVE_TAB,
		payload: payload
	});
};

export const clearBuyerRequest = () => async (dispatch) => {
	await dispatch({
		type: Types.CLEAR_BUYER_REQUEST
	});
};
